import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AppConfigProvider } from './context/AppContextProvider';
import { ModalProvider } from './features/modal/ModalProvider';
import { UserContextProvider } from './context/UserContextProvider';
import { CampusContextProvider } from './context/CampusContextProvider';

import store from './store';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 2 } },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AppConfigProvider>
          <UserContextProvider>
            <CampusContextProvider>
              <ModalProvider>
                <App />
              </ModalProvider>
            </CampusContextProvider>
          </UserContextProvider>
        </AppConfigProvider>
      </QueryClientProvider>
    </Provider>
  </BrowserRouter>
);
